module.exports = __webpack_public_path__ + "static/meetLinda_4-304c76e51221365a57a3c4743a76bf11.jpg";